import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { TaskListModeEnum } from '../../inbox/shared/enums';
import { TaskListConfiguration } from '../../inbox/shared/models';
import { SortService } from '../../inbox/task-list-sort/task-list-sort.service';
import { SearchService } from '../shared/search.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchResultsComponent implements OnInit {
  @Input() taskListConfiguration: TaskListConfiguration;

  resultsCounter = 0;
  sortId: number = null;
  taskListMode = TaskListModeEnum.Search;
  searchFiltersMap: Map<string, { id: string; label: string; clearFn: any }> = new Map();

  constructor(searchService: SearchService, private sortService: SortService) {
    searchService.searchFiltersBS.subscribe(result => (this.searchFiltersMap = result));
  }

  async ngOnInit() {
    this.sortId = await this.sortService.getSortId(this.taskListMode, null);
    this.taskListConfiguration.sort_type_id = this.sortId;
  }

  updateResultsCounter(number: number) {
    this.resultsCounter = number;
  }
}
